import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  CardMedia,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { size, COLORS } from "../../utils";
import BarChartIcon from "../../assets/icons/bar";
import TimeIcon from "../../assets/icons/time";
import CertificateIcon from "../../assets/icons/certificate";
import ListIcon from "../../assets/icons/tasklist";
import PatchIcon from "../../assets/icons/patch";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Enroll from "./Enroll";
import QuotesLeftIcon from "../../assets/icons/quotesleft";

export default function CourseExplore(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data } = props;
  const syllabus = data.syllabus;

  const COURSE_TYPES = {
    1: "Programming",
    2: "Artificial Intelligence",
    3: "Web Development",
    4: "Mobile App Development",
    5: "Designing",
    6: "Other",
  };

  const d1 = {
    "Skill level": { icon: BarChartIcon },
    "Time to complete": { icon: TimeIcon },
    Certificate: { icon: CertificateIcon },
    Prerequesties: { icon: ListIcon },
  };

  const [expanded, setExpanded] = useState(false);
  const [allExpanded, setAllExpanded] = useState(false);
  const [open, setOpen] = useState(false);

  const CLRS = {
    1: "#A2E8D7E0",
    2: "#9CC0F9E0",
    3: "#FFC8BBE0",
  };

  const handleChange = (index) => (event, isExpanded) =>
    setExpanded(isExpanded ? index : false);

  /* ---------------------------- REVIEWS CAROUSEL LOGIC ---------------------------- */

  const reviewKeys = Object.keys(syllabus.reviews);
  const [, setIndex] = React.useState(0);

  // Auto-scroll
  React.useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviewKeys.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [reviewKeys.length]);

  /* ---------------------------- RETURN UI ---------------------------- */

  return (
    <div style={{ backgroundColor: "transparent", position: "relative" }}>
      {/* TOP BG */}
      <div
        style={{
          top: 0,
          left: 0,
          position: "absolute",
          width: size({ p: 100 }),
          height: size({ p: 50, h: true }),
          backgroundColor: COLORS.WHITE,
        }}
      />

      {/* MAIN SECTION */}
      <Grid
        container
        flexWrap={"nowrap"}
        direction={"column"}
        rowGap={size({ p: 5, h: true })}
        position={"relative"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {/* HEADER CARD */}
        <Grid
          item
          container
          flexWrap={"nowrap"}
          alignItems={"center"}
          height={isMobile ? size({ p: 32 }) : size({ p: 32, h: true })}
          width={isMobile ? size({ p: 90 }) : size({ p: 58 })}
          marginTop={size({ p: 5, h: true })}
          columnGap={size({ p: 1 })}
          sx={{
            background: `radial-gradient(57.03% 76.98% at 100% 0%,#ffffff 0%,rgba(255,255,255,0) 100%),#031c26`,
            backgroundBlendMode: "overlay,normal",
            borderRadius: size({ p: 1.5 }),
            padding: `0px ${size({ p: 2 })}`,
            boxShadow: `rgba(0, 0, 0, 0.1) 0px 2px 8px`,
          }}
        >
          <Grid
            item
            container
            direction={"column"}
            width={size({ p: 38 })}
            rowGap={size({ p: 2, h: true })}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Archia",
                  fontSize: isMobile ? size({ p: 2 }) : size({ p: 0.9 }),
                  color: COLORS.WHITE,
                }}
              >
                <Box
                  component={"span"}
                  sx={{
                    color: COLORS.C1,
                    backgroundColor: COLORS.C3,
                    padding: `${size({ p: 0.5, h: true })} ${size({
                      p: 0.8,
                    })}`,
                    borderRadius: size({ p: 1 }),
                    marginRight: size({ p: 0.6 }),
                  }}
                >
                  {COURSE_TYPES[data.type]}
                </Box>
                Course
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Archia",
                  fontWeight: 600,
                  fontSize: isMobile ? size({ p: 3.5 }) : size({ p: 2.5 }),
                  textTransform: "capitalize",
                  color: COLORS.WHITE,
                }}
              >
                {data.name}
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Archia",
                  fontWeight: 400,
                  fontSize: isMobile ? size({ p: 1.6 }) : size({ p: 0.9 }),
                  color: COLORS.WHITE + "A0",
                  textAlign: "justify",
                }}
              >
                {syllabus.description}
              </Typography>
            </Grid>
          </Grid>

          <Grid item>
            <CardMedia
              component={"img"}
              image={data.icon}
              sx={{
                width: size({ p: 12 }),
                height: size({ p: 12 }),
              }}
            />
          </Grid>
        </Grid>

        {/* COURSE STATS */}
        <Grid
          item
          container
          flexWrap={"nowrap"}
          alignItems={"center"}
          justifyContent={"space-evenly"}
          height={isMobile ? size({ p: 16 }) : size({ p: 14, h: true })}
          width={isMobile ? size({ p: 90 }) : size({ p: 58 })}
          sx={{
            backgroundColor: COLORS.WHITE + "A0",
            border: `${size({ p: 0.05 })} solid ${COLORS.C2}`,
          }}
        >
          {Object.keys(d1).map((k) => {
            const Icon = d1[k].icon;
            return (
              <Grid
                item
                container
                flexWrap={"nowrap"}
                columnGap={size({ p: 0.8 })}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Grid item>
                  <Icon
                    width={isMobile ? size({ p: 4 }) : size({ p: 2.5 })}
                    height={isMobile ? size({ p: 4 }) : size({ p: 2.5 })}
                    fill={COLORS.C2}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: "Archia",
                      fontSize: isMobile ? size({ p: 1.8 }) : size({ p: 0.8 }),
                      fontWeight: 500,
                      color: COLORS.C2,
                    }}
                  >
                    {k}
                    <br />
                    <Box
                      component={"span"}
                      sx={{
                        fontSize: isMobile ? size({ p: 2 }) : size({ p: 1 }),
                        fontWeight: 700,
                      }}
                    >
                      {syllabus[k]}
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
            );
          })}
        </Grid>

        {/* ABOUT + SKILLS */}
        <Grid
          item
          container
          flexWrap={"nowrap"}
          alignItems={"start"}
          width={isMobile ? size({ p: 85 }) : size({ p: 55 })}
          justifyContent={"center"}
          columnGap={size({ p: 4 })}
        >
          {/* ABOUT */}
          <Grid
            item
            container
            direction={"column"}
            rowGap={size({ p: 1, h: true })}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Archia",
                  fontSize: isMobile ? size({ p: 2.5 }) : size({ p: 1.2 }),
                  fontWeight: 600,
                  color: COLORS.C2,
                }}
              >
                About this course
              </Typography>
            </Grid>

            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Space Mono",
                  fontSize: isMobile ? size({ p: 2 }) : size({ p: 0.8 }),
                  fontWeight: 400,
                  color: COLORS.BLACK + "A0",
                  textAlign: "justify",
                }}
              >
                {syllabus.about}
              </Typography>
            </Grid>
          </Grid>

          {/* SKILLS */}
          <Grid
            item
            container
            width={isMobile ? size({ p: 55 }) : size({ p: 25 })}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: "Archia",
                  fontSize: isMobile ? size({ p: 2.5 }) : size({ p: 1.2 }),
                  fontWeight: 600,
                  color: COLORS.C2,
                }}
              >
                Skills you'll gain
              </Typography>
            </Grid>
            <Grid item>
              <List>
                {syllabus.skills.map((p, i) => (
                  <ListItem disablePadding key={i}>
                    <ListItemIcon sx={{ minWidth: 0 }}>
                      <PatchIcon
                        fill={COLORS.C2}
                        width={isMobile ? size({ p: 2.5 }) : size({ p: 1 })}
                        height={isMobile ? size({ p: 2.5 }) : size({ p: 1 })}
                      />
                    </ListItemIcon>
                    <ListItemText>
                      <Typography
                        sx={{
                          fontFamily: "Space Mono",
                          fontSize: isMobile
                            ? size({ p: 2 })
                            : size({ p: 0.8 }),
                          fontWeight: 400,
                          color: COLORS.BLACK + "A0",
                          paddingLeft: size({ p: 0.4 }),
                        }}
                      >
                        {p}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>

        {/* SYLLABUS SECTION */}
        <Grid
          item
          width={isMobile ? size({ p: 90 }) : size({ p: 58 })}
          sx={{
            background: COLORS.WHITE,
            border: `${size({ p: 0.08 })} solid ${COLORS.C2}`,
          }}
        >
          <Grid
            container
            flexWrap={"nowrap"}
            height={
              isMobile ? size({ p: 8, h: true }) : size({ p: 12, h: true })
            }
            alignItems={"center"}
            sx={{ padding: `0px ${size({ p: 1.5 })}` }}
          >
            <Grid
              item
              container
              direction={"column"}
              rowGap={size({ p: 0.8, h: true })}
            >
              <Grid item>
                <Typography
                  sx={{
                    fontFamily: "Archia",
                    fontSize: isMobile ? size({ p: 3.5 }) : size({ p: 1.5 }),
                    fontWeight: 600,
                    color: COLORS.C2,
                  }}
                >
                  Syllabus
                </Typography>
              </Grid>

              <Grid item>
                <Typography
                  sx={{
                    fontFamily: "Archia",
                    fontSize: isMobile ? size({ p: 2 }) : size({ p: 0.9 }),
                    fontWeight: 400,
                    color: COLORS.BLACK + "A0",
                  }}
                >
                  {Object.keys(syllabus.modules).length} Modules
                </Typography>
              </Grid>
            </Grid>

            <Grid item width={isMobile ? size({ p: 65 }) : size({ p: 30 })}>
              <Typography
                component={"span"}
                onClick={() => setAllExpanded(!allExpanded)}
                sx={{
                  fontFamily: "Space Mono",
                  fontSize: isMobile ? size({ p: 2.8 }) : size({ p: 0.9 }),
                  fontWeight: 600,
                  color: COLORS.C6,
                  cursor: "pointer",
                  float: "right",
                  "&:hover": { backgroundColor: COLORS.BLACK + "10" },
                }}
              >
                {allExpanded ? "Collapse all sections" : "Expand all sections"}
              </Typography>
            </Grid>
          </Grid>

          {/* ACCORDIONS */}
          {Object.keys(syllabus.modules).map((k, i) => (
            <Accordion
              disableGutters
              expanded={expanded === i || allExpanded}
              onChange={handleChange(i)}
              sx={{
                border: "none",
                boxShadow: "none",
                backgroundColor: COLORS.WHITE,
              }}
            >
              <AccordionSummary
                expandIcon={
                  syllabus.modules[k].length > 0 ? (
                    <ExpandMoreIcon
                      sx={{
                        color: COLORS.C1,
                        fontSize: isMobile
                          ? size({ p: 4.5 })
                          : size({ p: 2.5 }),
                      }}
                    />
                  ) : null
                }
                sx={{
                  borderTop: `${size({ p: 0.08 })} solid ${COLORS.C2}`,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: size({ p: 1 }),
                    paddingLeft: size({ p: 0.5 }),
                  }}
                >
                  {/* NUMBER CIRCLE */}
                  <div
                    style={{
                      fontFamily: "Space Mono",
                      fontSize: isMobile ? size({ p: 2.7 }) : size({ p: 1.1 }),
                      fontWeight: 600,
                      color: COLORS.WHITE,
                      backgroundColor: COLORS.C2,
                      borderRadius: "50%",
                      height: isMobile ? size({ p: 5.5 }) : size({ p: 2.5 }),
                      width: isMobile ? size({ p: 5.5 }) : size({ p: 2.5 }),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0, // <-- ⭐ ADDED FIX (keeps circle perfect)
                    }}
                  >
                    {i + 1}
                  </div>

                  {/* TITLE */}
                  <Typography
                    sx={{
                      fontFamily: "Space Mono",
                      fontSize: isMobile ? size({ p: 2.1 }) : size({ p: 1.1 }),
                      fontWeight: 600,
                      color: COLORS.C2,
                      lineHeight: 1.3,
                    }}
                  >
                    {k}
                  </Typography>
                </div>
              </AccordionSummary>

              <AccordionDetails sx={{ paddingLeft: size({ p: 6 }), mt:'-1rem' }}>
                <List>
                  {syllabus.modules[k].map((p, j) => (
                    <ListItem disablePadding key={j}>
                      <ListItemIcon sx={{ minWidth: 0 }}>
                        <PatchIcon
                          fill={COLORS.C2}
                          width={isMobile ? size({ p: 2.5 }) : size({ p: 1.2 })}
                          height={
                            isMobile ? size({ p: 2.5 }) : size({ p: 1.2 })
                          }
                        />
                      </ListItemIcon>

                      <ListItemText>
                        <Typography
                          sx={{
                            fontFamily: "Space Mono",
                            fontSize: isMobile
                              ? size({ p: 2 })
                              : size({ p: 1 }),
                            color: COLORS.BLACK + "A0",
                            paddingLeft: size({ p: 0.6 }),
                          }}
                        >
                          {p}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>

        {/* ENROLL BUTTON */}
        <Grid item height={size({ p: 10, h: true })} mb={"5rem"}>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{
              backgroundColor: COLORS.C2,
              fontFamily: "Space Mono",
              fontSize: isMobile ? size({ p: 2.4 }) : size({ p: 1 }),
              height: isMobile
                ? size({ p: 4, h: true })
                : size({ p: 5, h: true }),
              width: isMobile ? size({ p: 20, h: true }) : size({ p: 12 }),
              ":hover": { backgroundColor: COLORS.C1 },
            }}
          >
            Enroll
          </Button>
        </Grid>
      </Grid>

      {/* ---------------- REVIEWS CAROUSEL ---------------- */}
      <Grid
        container
        flexWrap={"nowrap"}
        width={isMobile ? size({ p: 90 }) : size({ p: 80 })} // YOUR SAME WIDTH
        height={size({ p: 55, h: true })}
        mt={isMobile ? size({ p: 0, h: true }) : size({ p: 8, h: true })}
        sx={{
          position: "relative",
          overflow: "hidden",
          margin: "auto",
        }}
      >
        {/* Left Fade */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: "70px",
            pointerEvents: "none",
            zIndex: 10,
            background: `linear-gradient(to right, ${COLORS.WHITE}, ${COLORS.WHITE}00)`,
          }}
        />

        {/* Right Fade */}
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            width: size({ p: 10 }),
            height: "100%",
            zIndex: 10,
            background: `linear-gradient(to left, ${COLORS.WHITE}, ${COLORS.WHITE}00)`,
            pointerEvents: "none",
          }}
        />

        {/* Auto-scroll wrapper */}
        <Box
          sx={{
            display: "flex",
            gap: size({ p: 2 }),
            animation: "scrollReviews 100s linear infinite",
            "@keyframes scrollReviews": {
              "0%": { transform: "translateX(0)" },
              "100%": { transform: "translateX(-50%)" },
            },
          }}
        >
          {/* Duplicate list for infinite loop */}
          {[
            ...Object.keys(syllabus.reviews),
            ...Object.keys(syllabus.reviews),
          ].map((i, idx) => (
            <Grid
              item
              key={idx}
              width={isMobile ? size({ p: 28 }) : size({ p: 16 })} // EXACT YOUR CARD WIDTH
              height={
                isMobile ? size({ p: 41.5, h: true }) : size({ p: 50, h: true })
              } // EXACT YOUR HEIGHT
              sx={{
                position: "relative",
                backgroundColor: CLRS[(idx % 3) + 1], // SAME COLOR LOGIC
                border: `${size({ p: 0.05 })} solid ${COLORS.C2}`,
                flexShrink: 0,
              }}
            >
              {/* Upper left dot pattern */}
              <Box
                sx={{
                  top: size({ p: 1.6, h: true }),
                  left: size({ p: 0.8, neg: true }),
                  position: "absolute",
                  backgroundImage: `
                radial-gradient(${COLORS.BLACK} ${size({
                    p: 0.025,
                  })}, transparent ${size({ p: 0.025 })})
              `,
                  backgroundSize: `${size({ p: 0.2 })} ${size({ p: 0.2 })}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.25,
                }}
              />

              {/* Bottom pattern */}
              <Box
                sx={{
                  bottom: size({ p: 1.8, h: true, neg: true }),
                  left: size({ p: 0.01, neg: true }),
                  position: "absolute",
                  backgroundImage: `
                radial-gradient(${COLORS.C1} ${size({
                    p: 0.025,
                  })}, transparent ${size({ p: 0.025 })})
              `,
                  backgroundSize: `${size({ p: 0.2 })} ${size({ p: 0.2 })}`,
                  width: "100%",
                  height: "100%",
                  opacity: 0.15,
                  zIndex: 3,
                }}
              />

              {/* Quote Icon */}
              <QuotesLeftIcon
                fill={COLORS.C2}
                width={isMobile ? size({ p: 5.5 }) : size({ p: 3.5 })}
                height={isMobile ? size({ p: 5.5 }) : size({ p: 3.5 })}
                style={{
                  position: "absolute",
                  top: isMobile
                    ? size({ p: 1.1, h: true, neg: true })
                    : size({ p: 0.5, h: true, neg: true }),
                  left: size({ p: 1 }),
                }}
              />

              {/* Review content */}
              <Grid
                container
                flexWrap={"nowrap"}
                direction={"column"}
                height={
                  isMobile ? size({ p: 37, h: true }) : size({ p: 44, h: true })
                }
                rowGap={size({ p: 1, h: true })}
                mt={size({ p: 6, h: true })}
                sx={{
                  padding: `0px ${size({ p: 1 })}`,
                  position: "relative",
                }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: "Space Mono",
                      fontSize: isMobile ? size({ p: 2 }) : size({ p: 0.8 }),
                      fontWeight: 600,
                      color: COLORS.C2,
                    }}
                  >
                    {syllabus.reviews[i]?.review}
                  </Typography>
                </Grid>

                {/* Name */}
                <Grid
                  item
                  sx={{
                    position: "absolute",
                    bottom: size({ p: 3, h: true }),
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Space Mono",
                      fontSize: isMobile ? size({ p: 2 }) : size({ p: 0.8 }),
                      fontWeight: 200,
                      color: COLORS.BLACK + "A0",
                    }}
                  >
                    {syllabus.reviews[i]?.name}
                    <br />
                    Verified Student
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Grid>

      <Enroll onClose={() => setOpen(false)} data={data} open={open} />
    </div>
  );
}
